// extracted by mini-css-extract-plugin
export var header = "_t4-1";
export var maskBottom = "_t4-6";
export var maskMiddle = "_t4-7";
export var maskTop = "_t4-5";
export var root = "_t4-0";
export var scrollDownButton = "_t4-3";
export var scrollDownButtonHidden = "_t4-4";
export var viewport = "_t4-2";